

import { onFontsReady } from "../utils/onFontsReady";
import { initFontsGate } from "../utils/initFontsGate";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
initFontsGate("Manrope", [400, 700]);

function initProductsGrid(grid) {
	if (!grid || grid.dataset.gsapProductsInited) return;
	grid.dataset.gsapProductsInited = "1";

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

	const items = Array.from(grid.querySelectorAll(".product-item"));
	if (!items.length) return;

	gsap.set(items, { opacity: 0, y: 14 });

	gsap.to(items, {
		opacity: 1,
		y: 0,
		duration: 0.55,
		stagger: 0.30,
		ease: "power2.out",
		clearProps: "transform,opacity",
		scrollTrigger: {
			trigger: grid,
			start: "top 75%",
			once: true,
			invalidateOnRefresh: true,
			// markers: true,
		},
	});
}

onFontsReady(() => {
	document.querySelectorAll(".wv-gsap-products-page").forEach(initProductsGrid);
	ScrollTrigger.refresh();
});
